module.exports = __webpack_public_path__ + "img/icon-fist.cc947583.png";